/* eslint-disable no-nested-ternary */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import Head from 'next/head';
import { useRouter } from 'next/router';
import { GetStaticProps } from 'next/types';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-use';

// eslint-disable-next-line import/no-cycle
import AgreementPageFooter from '@/components/AgreementPageFooter';
import useUpdateWrapperMinWidthStyleForPolicy from '@/hooks/useUpdateWrapperMinWidthStyleForPolicy';
import { getAgreementLatest, getAgreementDetail } from '@/request/agreement';

import style from './style.module.scss';
// import useHideIm from '@/hooks/useHideIm';

export type AgreementItem = {
  uuid: string;
  name: string;
  version: string;
  agreementType: 'STU_CENTER_USER_AGREEMENT' | 'STU_CENTER_PRIVACY_POLICY';
  content: string;
  enabled: true;
  whenModified: string;
  whenCreated: string;
};

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['home', 'common'])),
    },
  };
};
const titleMap = {
  STU_CENTER_USER_AGREEMENT: '用户协议',
  STU_CENTER_PRIVACY_POLICY: '隐私政策',
};

const Agreement = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation(['home', 'common']);
  const {
    agreementType = 'STU_CENTER_PRIVACY_POLICY',
    uuid,
    index,
  } = router.query;
  const [detail, setDetail] = useState<AgreementItem>();
  const state = useLocation();
  // useHideIm(true);
  useUpdateWrapperMinWidthStyleForPolicy(true);
  const handleAgreementLatest = async () => {
    if (uuid) {
      const res = await getAgreementDetail({ uuid } as any);
      setDetail(res.data || res);
    } else {
      const res = await getAgreementLatest(
        agreementType as AgreementItem['agreementType'],
      );
      setDetail(res?.data || res);
    }
  };
  useEffect(() => {
    handleAgreementLatest();
  }, [agreementType]);

  const goHistory = () => {
    router.push('/policy/history');
  };
  const renderBtn = () => {
    if (uuid) {
      return (
        <span
          className={`${style.versionButton} ${style.back}`}
          onClick={() => router.push('/policy/history')}>
          {t('home:返回')}
        </span>
      );
    }
    return (
      <span className={style.versionButton} onClick={goHistory}>
        {t('home:查看历史版本')}
        <span className={style.arrow} />
      </span>
    );
  };
  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t(`home:${titleMap[agreementType as keyof typeof titleMap]}`),
          description: t('common:seo-隐私条款-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t(
                `home:${titleMap[agreementType as keyof typeof titleMap]}`,
              ),
            },
          ],
        }}
      />
      <Head>
        <title>
          {t(`home:${titleMap[agreementType as keyof typeof titleMap]}`)}
        </title>
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t(
            `home:${titleMap[agreementType as keyof typeof titleMap]}`,
          )}
        />
        <style
          dangerouslySetInnerHTML={{
            __html: `
                #footer {
                    display: none !important;
                }
            `,
          }}
        />
      </Head>
      <div
        className={style.agreement}
        style={{
          fontFamily: `${i18n.language === 'en' ? 'Roboto' : '"PingFang SC", "Microsoft YaHei"'}`,
        }}>
        {agreementType === 'STU_CENTER_PRIVACY_POLICY' && (
          <div className={style.historyEntrance}>
            <span className={style.leftContent}>
              <img src="/images/agreement/icon-warning-fill.svg" />
              {index === '0' || index === undefined ? (
                <>
                  {t('home:最新版本')}: v{detail?.version}
                </>
              ) : (
                t('home:当前为历史版本')
              )}
            </span>
            {renderBtn()}
          </div>
        )}
        <div
          className={style.agreementDetail}
          dangerouslySetInnerHTML={{ __html: detail?.content || '' }}
        />
        <AgreementPageFooter />
      </div>
    </>
  );
};

export default Agreement;
